import _default from './createPaginationItems';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/lib/createPaginationItems/index.js
// module id = 973
// module chunks = 0